import React from 'react'
import SEOHead from '../components/shared/SEOHead'
import { getPageSEO } from '../utils/seoConfig'
import LandingPageNavbar from '../components/landing-page/LandingPageNavbar'
import Pricing from '../components/landing-page/Pricing'

const PricingPage: React.FC = () => {
  return (
    <>
      <SEOHead seo={getPageSEO("pricing")} />
      <LandingPageNavbar />
      <Pricing />
    </>
  )
}

export default PricingPage
